import React from "react";
import { NavList } from "../../shared/";

const PersonaAppList = () => {
    const personaAppList = [
        { url: "/abbvie-pro/persona/group", name: "Persona Group" },
        { url: "/abbvie-pro/persona/audience", name: "Persona Audience" },
    ];

    return (
        <NavList backUrl="/abbvie-pro" title="Persona Application List" navList={personaAppList} />
    );
};

export default PersonaAppList;
